module.exports = __webpack_public_path__ + "img/MNE.05500885.svg";